/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import styled from 'styled-components';
import { getBaseInputStyles } from '@chegg-ui/input';
export var BasicStyledTextarea = styled.textarea.withConfig({
  componentId: "lff0i6-0"
})(["", " ", " ", ""], function (props) {
  return getBaseInputStyles(props);
}, function (_ref) {
  var height = _ref.height;
  return "height: ".concat(height || '5rem', ";");
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && 'resize: none;';
});